import { render, staticRenderFns } from "./QueryComponent.vue?vue&type=template&id=0506146e"
import script from "./QueryComponent.vue?vue&type=script&lang=js"
export * from "./QueryComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports